import { render } from "./BillingCustomerDialog.vue?vue&type=template&id=23092068&ts=true"
import script from "./BillingCustomerDialog.vue?vue&type=script&lang=ts"
export * from "./BillingCustomerDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__